import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Orders from '../components/Orders';
import { ErrorMessage, Grid, PagerWrapper, useAsyncEffect } from 'ui-toolkit';
import { OrdersSearchForm } from '../components/OrdersSearchForm';
import { RootStore } from '../../store/types';
import {
  initClientOrdersSearch,
  setClientSearchOrderSorting,
  setClientSearchSettings,
} from '../store/clientOrdersSearch/dispatch';
import '../scss/_App.scss';
import { getCountyForStateAction } from '../../store/counties';
import { CardTW } from '../../tailwindComponents/CardTW/CardTW';
import { useGetUserType } from 'components/accessControl/hooks/useGetUserType';
import { doGetAsyncAssociatedLendersForClient } from '../../ui-toolkit/associatedLenders/dispatch';
import { useAssociatedLendersContext } from '../../ui-toolkit/associatedLenders/AssociatedLendersProvider';
import { eUSAState } from '../../ui-toolkit/enums/states';
import { ISearchOrdersSpecificationData } from '../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';
import { useAppDispatch } from '../../store/store';

export const OrdersActiveContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const userType = useGetUserType();
  const [{ associatedLenders }, setAssociatedLenders] = useAssociatedLendersContext();
  const { searchResult, searchResultFetchStatus, searchSettings, searchResultError } = useSelector(
    (state: RootStore) => state.clientOrdersSearch
  );
  const { counties, countiesError } = useSelector((state: RootStore) => state.counties);
  const onSortChange = (field: string, direction: 'asc' | 'desc') => {
    dispatch(setClientSearchOrderSorting(field, direction));
  };

  const onPageChange = (pageNumber: number) => dispatch(setClientSearchSettings({ ...searchSettings, pageNumber }));
  const onPageSizeChange = (pageSize: number) => dispatch(setClientSearchSettings({ ...searchSettings, pageSize }));
  const onSearchOrder = (value: ISearchOrdersSpecificationData) => dispatch(setClientSearchSettings(value));
  const onStateChange = (state: eUSAState | null) => (state ? dispatch(getCountyForStateAction(state)) : {});

  useEffect(() => {
    dispatch(initClientOrdersSearch());
  }, [dispatch]);

  useAsyncEffect(async () => {
    if (!associatedLenders.client || associatedLenders.client.length === 0) {
      await doGetAsyncAssociatedLendersForClient(setAssociatedLenders);
    }
  }, [associatedLenders.client, userType]);

  const pageError = searchResultError || countiesError;

  return (
    <Grid>
      <ErrorMessage message={pageError} />
      <CardTW>
        <OrdersSearchForm
          lenders={associatedLenders.client || []}
          onSearchOrder={onSearchOrder}
          counties={counties}
          onStateSelect={onStateChange}
        />
      </CardTW>
      <CardTW>
        <Grid>
          <PagerWrapper
            total={searchResult.totalElements}
            page={searchSettings.pageNumber}
            pageSize={searchSettings.pageSize}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            disabled={searchResultFetchStatus.fetching}
          >
            <Orders
              loading={searchResultFetchStatus.fetching}
              orders={searchResult.content}
              userType={userType}
              onSortChange={onSortChange}
            />
          </PagerWrapper>
        </Grid>
      </CardTW>
    </Grid>
  );
};
